import { render, staticRenderFns } from "./EditCertification.vue?vue&type=template&id=67386945&"
import script from "./EditCertification.vue?vue&type=script&lang=js&"
export * from "./EditCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports